import React, { Component } from 'react'
import { statistic } from '@util'
import style from './style.module.less'
import { Badge } from 'hljd'

export default class extends Component {
  onClick = () => {
    const { stat, path } = this.props
    statistic(stat)
    const link = typeof path === 'function' ? path() : path
    if (link) {
      window.location.href = link
      return
    }
  }

  render() {
    const { name, icon, total } = this.props
    return (
      <Badge
        count={total}
        offset={[-26]}
        style={{ background: '#FF4B4B', padding: '0 6px' }}
      >
        <div onClick={this.onClick} className={style.item}>
          <i className={`iconfont ${icon || 'icon-manage_fill'}`} />{' '}
          <span>{name}</span>
        </div>
      </Badge>
    )
  }
}
